const css = `.LJvPdq__bottomAxis{fill:var(--base-text-default)}`;
document.head
    .appendChild(document.createElement("style"))
    .appendChild(document.createTextNode(css));
export {css};

export default {"bottomAxis":"LJvPdq__bottomAxis"};
